import {
  Briefcase, Rocket, Users, Heart, Target, Megaphone,
  Edit3, Compass, TrendingUp, Search, DollarSign, Zap,
  FileText, Sparkles
} from 'lucide-react';

export const templateIcons = {
  briefcase: Briefcase,
  rocket: Rocket,
  users: Users,
  heart: Heart,
  target: Target,
  megaphone: Megaphone,
  edit: Edit3,
  compass: Compass,
  trending: TrendingUp,
  search: Search,
  dollar: DollarSign,
  zap: Zap,
  newspaper: FileText,
  lightbulb: Sparkles
};
